/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const CardVerificationResult = {
  NoMatch: "noMatch",
  Match: "match",
  NotChecked: "notChecked",
  Unavailable: "unavailable",
  PartialMatch: "partialMatch",
} as const;
export type CardVerificationResult = ClosedEnum<typeof CardVerificationResult>;

/** @internal */
export const CardVerificationResult$inboundSchema: z.ZodNativeEnum<
  typeof CardVerificationResult
> = z.nativeEnum(CardVerificationResult);
/** @internal */
export const CardVerificationResult$outboundSchema: z.ZodNativeEnum<
  typeof CardVerificationResult
> = CardVerificationResult$inboundSchema;
